<template>
  <div class="three-product">
    <div class="product-items">

      <!-- <div class="product-item" v-for="(item, index) in indexVipCardItems" :key="index">
        <el-image :src="item.data" :fit="fit" @click="jumpBlankUrl(item.url, null)"></el-image>
      </div> -->
      
    </div>

    <!-- <UpgradeMember /> -->
  </div>
</template>
<script setup>
import UpgradeMember from '@/components/UpgradeMember.vue'
import { useConfigStore } from '@/stores';
import { storeToRefs } from 'pinia';
import { jumpBlankUrl } from '@/utils/jump';


const configStore = useConfigStore();
const configState = storeToRefs(configStore);
const { indexVipCardItems } = configState;

 // eslint-disable-next-line
const props = defineProps({
  buyClick: {
    type: Function,
    required: true
  }
});

const buyVip = (platformCode) => {
  props.buyClick(platformCode)
}
</script>
<style scoped>
.three-product {
  width: 100%;
  height: 1100px;
  background: url(@/assets/images/three-product-bg.jpg) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.product-items {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.product-item {
  width: 360px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  filter: drop-shadow(#999 10px 10px 10px);
}
.product-item:nth-of-type(1) .product-item-icon {
  width: 89px;
  height: 78px;
  background: url(@/assets/images/product-item1.png) no-repeat;
}
.product-item:nth-of-type(2) .product-item-icon {
  width: 78px;
  height: 78px;
  background: url(@/assets/images/product-item2.png) no-repeat;
}
.product-item:nth-of-type(3) .product-item-icon {
  width: 80px;
  height: 76px;
  background: url(@/assets/images/product-item3.png) no-repeat;
}
.product-item-card {
  width: 360px;
  height: 460px;
  border-radius: 4px;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  color: #fff;
}
.product-item-card-top {
  border-radius: 20px 20px 0 0;
  width: 100%;
  height: 180px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.product-item:nth-of-type(1) .product-item-card .product-item-card-top {
  background: rgba(68, 175, 224, 1);
}
.product-item:nth-of-type(2) .product-item-card .product-item-card-top {
  background-color: #f6b443;
}
.product-item:nth-of-type(3) .product-item-card .product-item-card-top {
  background-color: #82c8c8;
}
.product-item-card-top-title1 {
}
.product-item-card-top-title1 div:nth-of-type(1) {
  font-size: 36px;
}
.product-item-card-top-title1 div:nth-of-type(2) {
  font-size: 20px;
}
.product-item-card-top-title2 {
  font-size: 32px;
}
.product-item-card-bottom {
  background: rgba(220, 220, 220, 1);
  border-radius: 0 0 20px 20px;
  width: 100%;
  height: 280px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
}
.product-item-card-bottom-lists {
  display: flex;
  flex-direction: column;
  color: rgba(75, 75, 75, 1);
  gap: 8px;
  font-size: 24px;
  align-items: flex-start;
  padding-left: 60px;
  width: 100%;
  box-sizing: border-box;
}
.product-item-card-bottom-price {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 320px;
  height: 45px;
  border-radius: 20.7px;
  background: rgba(68, 175, 224, 1);
  cursor: pointer;
}
.product-item-card-bottom-price span {
  font-size: 70px;
  color: rgba(2, 50, 99, 1);
  font-style: oblique;
  font-weight: 600;
  letter-spacing: -5px;
  margin: 0 10px 18px 0;
}
.product-item:nth-of-type(1) .product-item-card-bottom-price {
  background: rgba(68, 175, 224, 1);
}
.product-item:nth-of-type(2) .product-item-card-bottom-price {
  background: #f6b443;
}
.product-item:nth-of-type(3) .product-item-card-bottom-price {
  background: #82c8c8;
}
</style>
